export default __webpack_public_path__ + "static/hairpedia-article-c8cdea4ed9ffbfbe96448b090eb31ed9.png";